<template>
  <RegionalBenefit>
    {{ i18n(translations.title) }}
    <template #appendix>
      {{ i18n(translations.body) }}
    </template>
  </RegionalBenefit>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import RegionalBenefit from '../RegionalBenefit/RegionalBenefit.vue'

import translations from './Plan200goFrance35goInternational15Countries.translations'

const i18n = useI18n()
</script>
